/**
 * États du contenu pédagogique (aligné avec Prisma)
 * Utilisé pour Teaching, Chapter, Lesson, Resource
 */
export enum PedagogicContentState {
  /** Brouillon - En cours de création, visible uniquement par le créateur */
  DRAFT = 'DRAFT',
  /** Actif - Utilisable et visible par les utilisateurs autorisés */
  ACTIVE = 'ACTIVE',
  /** Archivé - Plus utilisé mais conservé pour historique */
  ARCHIVED = 'ARCHIVED',
}

/**
 * Visibilité du contenu pédagogique (aligné avec Prisma)
 * Utilisé pour Chapter, Lesson, Resource
 */
export enum ContentVisibility {
  /** Privé - Visible uniquement par le propriétaire */
  PRIVATE = 'PRIVATE',
  /** Établissement - Visible par tous les membres de l'établissement */
  ESTABLISHMENT = 'ESTABLISHMENT',
  /** Public - Visible par tous */
  PUBLIC = 'PUBLIC',
}

export enum EstablishmentStatus {
  /** Actif - Utilisable et visible par les utilisateurs autorisés */
  ACTIVE = 'ACTIVE',
  /** Inactif - Plus utilisé mais conservé pour historique */
  INACTIVE = 'INACTIVE',
}

export enum EstablishmentCategory {
  /** Public - Utilisable et visible par les utilisateurs autorisés */
  PUBLIC = 'PUBLIC',
  /** Privé - Visible uniquement par le propriétaire */
  PRIVATE = 'PRIVATE',
}
